import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./Toolbar.module.css";

/* Toolbar */

export class Toolbar extends Component {
  render() {
    const { children } = this.props;

    return (
      <div className={styles.toolbar}>
        <div className={styles.toolbarRow}>{children}</div>
      </div>
    );
  }
}

Toolbar.propTypes = {
  children: PropTypes.node,
};

/* ToolbarGroup */

export class ToolbarGroup extends Component {
  render() {
    const { children, width, minWidth, align } = this.props;

    const style = {
      width,
      minWidth,
      textAlign: align,
    };

    return (
      <div className={styles.toolbarGroup} style={style}>
        <div className={styles.toolbarGroupWrapper}>{children}</div>
      </div>
    );
  }
}

ToolbarGroup.propTypes = {
  children: PropTypes.node,
};

/* ToolbarFlexibleSpacer */

export class ToolbarFlexibleSpacer extends Component {
  render() {
    return <div className={styles.toolbarGroup} />;
  }
}

/* ToolbarSpacer */

export class ToolbarSpacer extends Component {
  render() {
    return <div className={styles.toolbarSpacer} />;
  }
}
